<template>
  <div>
    <Lynx-Button
      v-if="hasRole('super-admin')"
      icon="User"
      color="success-base"
      icon-size="4"
      size="small"
      @click.native="openLogs()"
    />
    <v-snackbar color="primary" shaped v-model="modalLogs" :vertical="false">
      <div  v-for="(log, index) in logs" :key="index">
        <span >
          <b-tag style="font-size: 15px" :type="cor(log)"
          rounded>
            {{ status_logs[log.description] }}
          </b-tag>
          {{ log.nome_completo }}
          {{ formatEnToBr(log.created_at) }}</span
        >
      </div>
      <!-- <span style="font-size: 15px; margin-top: 10px;">DELETOU: {{ user_up.toUpperCase() }} </span> -->

      <template v-slot:action="{ attrs }">
        <v-btn color="error" icon v-bind="attrs" @click.native="hide()">
          <v-icon large> mdi-close </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import {hasRole} from "@/utils/can";
export default {
  props: {
    logs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      status_logs: {
        created: "Criou",
        updated: "Atualizou",
        deleted: "Deletou",
      },
      modalLogs:false,
    };
  },
  methods: {
    hasRole,
    openLogs() {
      this.modalLogs = true;
    },
    hide() {
      this.modalLogs = false;
    },
    formatEnToBr(date) {
      const momentDate = moment(date, "YYYY-MM-DD HH:mm:ss").format(
        "DD/MM/YYYY HH:mm:ss"
      );

      if (momentDate != "Invalid date") {
        return momentDate;
      } else {
        return "sem data";
      }
    },
    cor(log){
    switch (log.description) {
      case 'created':
      return 'is-success';
      case 'updated':
      return 'is-info';
      case 'deleted':
      return 'is-danger';
      default:
      return '';
    }
    }
  },
};
</script>